package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("animals")
@Composable
fun KidsAnimalsPage() {
    BlogLayout(
        PageProperties(
            "Animals",
            "Animals are found almost everywhere on Earth. Animals and their surroundings. Do all animals look same? No. They are of different shapes and sizes (Animals come in all shapes and sizes!)"
        ),
        BlogProperties("Kids", "Animals")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            SpanText(
                text = "Meaning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tail",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Antler, horns, rack, tines (શિંગડું) - Antlers (more than one)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hoof - ખૂર",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Barrow",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals are living beings that can move, eat, breathe and grow. Animals are found almost everywhere on Earth. Animals and their surroundings. Do all animals look same? No. They are of different shapes and sizes (Animals come in all shapes and sizes!).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Move: Animals can change their place by walking, running, flying, swimming or crawling.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Eat: Animals get their food from plants, other animals or both.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Breathe: Animals breathe; some use lungs, some use gills.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Grow and Reproduce: Animals grow from young ones to adults and have young ones of their own.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Senses: Animals use eyes, ears, nose and other sense organs to know about their surroundings.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Types of Animals Based on Size",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Big Animals: elephant, hippopotamus, giraffe. The elephant is the largest animal on land and the giraffe is the tallest one.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Small Animals: squirrel, rabbit, mouse",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tiny animals: Very small animals that may need a magnifying glass to be seen clearly. Examples: ant, bee, butterfly, mouse.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Eating Habits of Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All living things need food to grow and live. Both plants and animals are living things. Unlike plants, animals do not prepare their own food.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All animals do not eat the same type of food.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "How animals help us?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals such as cows, buffaloes and goats give us milk.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that give us milk are called milch animals (દૂધાળા પ્રાણીઓ).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We make curd, butter khoya, and cheese from milk.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Curd, butter and cheese are called dairy product.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Many people eat fish also.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Transportation: Elephants, bullocks, camels, donkeys and horses are used to carry goods. Horses, elephants and camels are also used to transport people from one place to another.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Farming: Animals such as oxen help us to draw water from wells and work in the fields.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Taking Care of Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals are living things that provide us with food and clothing. They help us in our work. We should be kind and loving to animals.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should not hunt animals for fun or sport. We should not cut trees as they are home to many animals.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should feed domestic animals and pets regularly. We should clean their shelters too.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should not tease or harm them.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If they are hurt or sick, we must take them to the vet.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Herbivores",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that eat only grass, leaves or other parts of plants are called herbivores.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Deer, horses, rhinoceroses, giraffes, rabbits, zebras, gorillas and parrotfish are herbivores.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Carnivores - (માંસાહારી)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that kill other animals for food are called carnivores.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leopards, snakes, wolves, cheetahs, tigers, lions, whales and sharks are carnivores.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Omnivores - (સર્વભક્ષી)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that eat plants as well as animals are called omnivores. Cats, dogs, hens, bears, rats, crows and goldfish are omnivores.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Aquatic - (જળચર)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Aquatic animals live in water for most or all of their life.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Many of them have gills to take oxygen from water; others come to the surface to breathe air.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Examples: fish, dolphin, shark, seahorse, octopus.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Crawling",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "snake, crocodiles, lizards, turtles",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Insects",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Insects are small animals that usually have six legs and often one or two pairs of wings.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some small animals such as spiders are not insects; they have eight legs.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Examples of insects: caterpiller, ladybird, cockroach, housefly, butterfly, grasshopper.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Extinct and Endangered Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )


            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Natural events, such as lightning, floods and human activities, such as hunting and cutting of trees, affect the number of different types of animals on the Earth.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Extinct animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If a particular type of animal does not exist anymore on the Earth, we say that it is extinct.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dinosaurs, dodo birds, woolly mammoths and Chinese paddlefish are extinct animals.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Endangered animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Endangered animals are those animals that exist on Earth in very small numbers and are in danger of becoming extinct. To save animals from becoming extinct we should stop killing them and we should protect them from being killed.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Javan rhino, saola, great Indian bustard and vaquita are endangered animals.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Eggs",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hens and ducks give us eggs.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Meat",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some people eat the meat of animals like goats, hens, ducks, pigs and fish.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Honey",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We get honey and beeswax from honey bees.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Clothing and Related Things",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wool: We get wool from sheep, camels and goats. We use wool to make sweaters, shawls, mufflers, socks, caps and gloves. Woollen clothes keep us warm.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leather: The skin of animals like snakes, crocodiles, deer, buffaloes, pigs and camels is used to make leather. Leather is used to make belts, bags and jackets.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Silk: Silkworms give us silk. It is used to make dupattas, dresses, sarees, bow, tie and scarves.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Pet Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that are kept for a persons company are called pet animals.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Domestic Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We look after some animals that are useful to us. We take care of them on farms. These animals are called domestic animals. cow, sheep, goat hen",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Domestic animals help us in many ways:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Dogs guard our homes and farms.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Cows, goat, sheep and buffaloes give us milk.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Sheep give us wool.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Goats, pigs, hens, sheep and fish give us meat.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Hens and ducks give us eggs.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Bullocks, donkeys, camels and horses pull carts and carry loads.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Pets Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We keep some animals in our homes. These animals are called pets. We enjoy their company. We feed them and take good care of them. We love our pets. Some domestic animals such as dogs are also kept as pets. Cats, rabbits, parrots and fish are also kept as pets by some families.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Wild Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals that live in nature are called wild animals. Some examples of wild animals are, wolves, koalas, zebras, rhinoceroses, deer and tigers. Some of these animals can also be seen in zoos.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Where Animals Live",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals live on land and in water.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Land: cheetah, camel, bear, buffalo, fox, tiger and leopard.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Water: dolphin, shark, whale, and octopus.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Land and Water: crocodile, duck, tortoise and frog.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tadpole is in the larval age of which animal? Frog",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Carry Animals: horse, bull, buffalo, elephant, camel etc.. These animals make our work easy.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dung of Animals (પ્રાણીઓનું છાણ): Dried dung of animals is used as a fuel.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Dead Animals",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We get leather from the skin of dead animals like buffaloes, camels, snakes and crocodiles. Leather (ચામડું) is used to make shoes, belts, bags and purses.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sheep",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We get wool from the sheep. Wool is the fur on the body of the sheep. Wool is used to make woolen clothes. We wear woolen clothes in winter. We get silk from silkworms. We use silk to make shirts, sarees and scarves (સ્કાર્ફ).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Beehe",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We get honey and wax (મીણ) from beehives (મધમાખીઓ). Wax is used to make candles.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Cat",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They are small in size. Their bodies are covered with smooth fur. They have two mesmerizing (मेज़्मराइज़िंग) (મંત્રમુગ્ધ કરનાર) eyes, two highly sensitive ears, four legs, whiskers (મૂછો) under their nose and a long tail.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Dog",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A dog is a friendly animal that can be a great pet (પાલતુ). Dogs guard our homes. They have four legs, a tail, and fur. Dogs need food, water, and a place to sleep. Dogs can bark, wag their tails, and run around.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Cow",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A cow is a domestic animal (પાળતુ પ્રાણી), often found on farms and in rural areas (ગ્રામ્ય વિસ્તારો). Cow milk is used to make various dairy products like cheese, butter, buttermilk, and yogurt (curd) (દહીં). They have four legs, two horns, two eyes, two ears, and a long tail.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Monkey",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Monkeys are fun and playful animals (રમતિયાળ પ્રાણીઓ) that live in trees. It jumps from tree to tree easily. It has a long tail, four legs and black face. Monkeys love to eat bananas. They live in groups called troops (જૂથ) or families.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Lion",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lion is a big, strong animal called the \"King of the Jungle\". Lions are known for their golden fur (સોનેરી રૂંવાટી) and the male lions have a big, fluffy (રુંવાટીવાળું) mane around their necks. Lions are known for their speed and hunting skills (શિકાર કરવાની કુશળતા).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Kangaroo",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kangaroos are amazing (અદ્ભુત) animals that hop around on their strong back legs. They are known for their big feet and long tails, which they use to balance. Kangaroos live in Australia.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Penguin (પેંગ્વિન)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Penguins are black and white birds that live in the cold (ઠંડા) places (સ્થળ). hey can't fly, but they are amazing swimmers! Penguins have a thick layer of fat and waterproof feathers to keep them warm in the icy water. They love to eat fish and other small sea creatures (જીવો).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Leopard",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A leopard is a big, strong animal with golden-brown fur and black spots. It lives in the jungle and is a good climber. Leopards are known for their speed and hunting skills. They are also skilled at hiding and stalking (પીછો કરવો) their prey.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Squirrel",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Squirrels typically have a long, bushy tail (ઝાડીવાળી) and small pointed ears",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Fish",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some animals live in water likes fish. They swim all the time!. Do fish breathe like us? No, they use gills.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Frog",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Frog lives in water as well as on land. In water, it breathes through skin and on land it breathes through lungs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Firehawks (ફાયરહોક્સ) bird Australia",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In Australia, certain birds like the black kite, whistling kite, and brown falcon deliberately spread wildfires by carrying burning sticks to new areas. These raptors, sometimes called firehawks, use fire to flush out prey such as insects, small mammals, and reptiles (સરિસૃપ), making them easier to catch.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Emu Australia",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Emu is Australia's tallest native bird, reaching between 1.6 m and 1.9 m when standing erect. Adult Emus are covered with shaggy grey-brown feathers except for the neck and head, which are largely naked and bluish-black. The wings are greatly reduced, but the legs are long and powerful.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }



            SpanText(
                text = "Animal Home",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cow - Shed",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pig - Sty",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Horse - Stable",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sheep - Sheep Pen",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dog - Kennel",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hen - Coop",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lion - Den",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rabbit - Wild-Burrow / Pet-Hutch",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Spider - Web",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bird - Nest",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The penguin is a bird that makes its nest on the ground with pebbles and stones that it collects.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

            }

            SpanText(
                text = "Animal Puppies Name",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sheep - Lamb",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cat - Kitten",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dog - Puppy",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cow - Calf",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Elephant - Calf",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lion - Cub",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bear - Cub",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rabbit - Bunny",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Horse - Foal",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Deer - Fawn",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pig - Piglet",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Frog - Tadpole",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Butterfly - Caterpillar",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Duck - Duckling",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hen - Chick",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Animals Sound",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mouse - Squeaks",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Horse - Neighs",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Snake - Hisses",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dog - Barks",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Goat - Bleats",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Owl - Hoots",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Monkey - Chatters",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Elephant - Trumpets",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lions - Roars",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Duck - Quacks",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Donkey - Brays",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Animals Action",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The horse trots.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lamb leaps.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The snake crawls.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The squirrel runs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The monkey swings.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Black color inside its mouth - What does the word 'black' in black mamba, one or the most venomous snakes in the world, actually refer. Despite its name, the snake is not black. Instead, it ranges in colour from gray to dark brown, with a lighter underside. The black actually refers to the colour of the inside of its mouth; green mambas and other snakes have white mouths.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tiger - Sumatran, Amur, and South China are subspecies of which big cat?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Guatemala - The currency of which of these countries is named after a bird?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Giant Panda - Which of these creatures is a black and white bear?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hilsa Fry - The name of which of these foods contains the name of an animal?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wolf - All domestic dogs are descendants of which of these?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Horse - The male of which animal is sometimes called a Stallion?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leg - In a horse, the hoof is found at the bottom of which body part? - It is the protective covering for the end of each of the animal's four limbs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kill two birds with one stone.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hilsa fry: Which of these dishes has the name of an animal in it?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange these animals according to the continents they are native to in this order: emu, Bengal tiger, anaconda, giraffe. Australia, Asia, South America, Africa",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these teeth of the elephant elongate and grow into tusks? upper incisors",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the Swahili language, what does the word 'simba' mean? Lion",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these do we commonly get from milk? Makkhan",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which insect's sting did the creator of the sting pain index Justin Schmidt compare to 'walking over flaming charcoal with a 3-inch nail in your heel'? Bullet ant (Paraponera clavata), Venezuela the bullet ant is known as the “24-hour ant",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What nickname does this lizard get due to its resemblance to a superhero? Spider-Man lizard",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "According to an English proverb, which animal cannot change its spots? A leopard cannot change its spots. The saying means that a person's core character or innate nature is unchangeable, even if they try to act differently.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these is obtained by clarifying butter? Ghee",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rottweiler is a breed of which of these? Dog",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nectar comprises a major portion of the diet of which of these birds? hummingbirds, sunbirds, and honeyeaters.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cyclone Tauktae gets its name from what kind of animal? Lizard",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which is the largest herbivore on land? African bush elephant",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The 'Panthera tigris tigris' is the scientific name of which animal? Bengal Tiger",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A 'curator' is someone who works at which of these? Museum",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these primates have tails? Langur",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which colour appears in the common name of the largest animal in existence? Blue Whale",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these national parks is located the southernmost? Silent Valley, Kaziranga, Jim Corbett, Bandhavgarh",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which country has the largest number of tigers in the wild? India",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which mythical creature completes the English name of this insect: Dragon fly?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The diet of a red panda mainly consists of which of these? Bamboo",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On which animal is the Golden Howdah placed during a Mysore festival? Elephant",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Zebras are native to which continent? African",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these birds has webbed feet? Duck",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The male bee is called by which of these English names that might also remind you of unmanned aerial vehicles? Drone",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The cuter skin of which of theseds mostly covered with scales? Fish",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                //Herbivores (Cows, Deer, Elephants, Giraffes, Rabbits, Zebras)
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these animals is not carnivorous? herbivore (eats only plants) or an omnivore",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Melghat in Maharashtra is a reserve for which of these animals? Tiger",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What commonly worn accessory by athletes shares its name with a breed of cow? Jersey",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these animals use colour changes to camouflage and communicate? Chameleon",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What kind of creature is Bagheera in 'The Jungle Book'? Black panther",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which animal is seen on the Reserve Bank of India logo? Tiger",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The dromedary, which has a single hump, is a type of which animal? Camel",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The endangered bird Narcondam Hornbill is endemic to which state or union territory? Narcondam Island, Andaman and Nicobar Islands",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these bird species is not extinct? Great Indian Bustard",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which long-necked animal was once called the camelopard? Giraffe",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The word 'canine' generally refers to which of these animals? Dog",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Anacondas are native to which continent? South America",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Who among these is the founder of the organisation, People For Animals? Maneka Gandhi",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If you are bitten by which of these animals would you have to take antivenom? Snake",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Swifts is Birds.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In which continent is this snow leopard (Panthera uncia) animal most likely to be found in the wild? Asia",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these animals completes this Hindi phrase meaning 'a friend who betrays you': asteen ka? Snake",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these birds can't move or roll their eyes inside their eye sockets? owls",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these animals is not mentioned in Rudyard Kipling's \"The Jungle Book\"? Gorilla",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "'Murrah' is a popular breed of which animal in India? Buffalo",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What was the name of the horse that Lord Buddha rode out on and later sent back during his Great Renunciation? Kanthaka, Pingala, Maitreya",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mukhi. who dave birth to five cubs at Kuno National 38:56 Aloksin Madhya Pradesh in 2025, is what kind of animal? cheetah",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                /*
                State Butterfly: Maharashtra (Blue Mormon), Tripura (Common Emperor).
                State Fruit: Tripura (Queen Pineapple).
                State Fish/Aquatic Animal: Kerala (Pearl Spot), Odisha (Mahseer).
                State Reptile: Andhra Pradesh (Cobra), Himachal Pradesh (Snow Leopard).
                State Motto: Maharashtra (Pratipaccandralēkhēva vardhiṣṇurviśva vanditā).
                State Emblem: Chhattisgarh (Adapted Ashoka Pillar).
                */
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Besides an animal, a bird, a tree, and a flower, some Indian states have also adopted which of these as a state symbol?  State Fruits, State Butterflies, State Fish, State Reptiles, State Aquatic",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The book 'The Art of Racing in the Rain' by Garth Stein is told through whose perspective? A dog",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these has a skeleton primarily made of cartilage? Shark",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these creatures has the least number of legs? Crow, Cow, Elephant",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these places is known as the 'Milk Capital of India'? Anand",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these animals cannot breathe underwater? Chameleons",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cocker Spaniel is a breed of which animal? Dog",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The typical gait of a horse is: walk, trot, and gallop",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = " A 'Conservation Project' to protect which of these animals was launched in 1975 in India, and marked its fiftieth anniversary in 2025? The conservation project launched in India in 1975, celebrating its 50th anniversary in 2025, was the Crocodile Conservation Project, aimed at protecting India's three native crocodile species: the gharial, mugger, and saltwater crocodile.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A 'leash' is usually used for which of these? Pets",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these is an ancient vehicle of war often pulled by horses? chariot",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Two of which of these physical features are present in a Bactrian camel, as opposed to one in the Arabian camel? hump(s)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which animal, found in the Himalayan regions of India, is this? Snow Leopard, Red Panda, Himalayan Tahr, Himalayan Black Bear, Bharal, Musk Deer",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Known as the 'Queen of Ranthambore', \"Machhli\" was an animal of which species? Tiger",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cow dung can be used as manure as it is rich in: Nitrogen, Phosphorus, and Potassium (NPK)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Birds like kites, eagles and vultures can see things from a distance of: Eight meters",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a delightful sight to find a herd (ટોળું) of cows grazing in the fields.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange these stages of a silkworm's life chronologically: Egg, Caterpillar, Moth, Cocoon",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Iguana is a genus of herbivorous lizards.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Indian Star and Burmese Star are species of what?. Indian Star and the Burmese Star are distinct species of tortoises named for the striking, star-shaped yellow or orange radiating patterns on their domed shells.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "he second-largest butterfly in India is the Southern Birdwing, which is also known as the Sahyadri birdwing (Troides minos).",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            //Bird: Mynah
            //IIT, NIT, IISER, AIIMS, FIFA, Right to Information, Right to Life, Right to Privacy, Right to Education,
            //Stand for - IPO, CEO, FYI
            //Open Era
            //Heliopolis War
            //Greta Thunberg time's 100 Most Influential People

            //The TV sitcom "Wagle Ki Duniya" is based on characters created by which noted cartoonist? R K Laxman

            //Ordering
            //Aga Khan Girls School
            //Domain name .in .org .com
            //Logo design name Sahitya Akademi (Satyajit Ray)
            //ghoomar,
            //File Format, Audio, Video, Document, Picture
            //1/2, 1/4, 1/3, 1/5
            //Termite Animal
            //Military exercise: Garuda Shakti
            //Ancient universities
            //Maharatna company
            //Pavel Durov is the founder and owner of messaging app Telegram.
            //Which of these imaginary geographical lines will be the southernmost? Tropic of Capricorn
            //Pandava these Pandava in ascending order?
            //The desktop application of which web browser will be retired and will go without support from June 2022?
            //Which of these stages of life, according to Indian tradition, comes first? Brahmacharya, Grihastha, Vanaprastha, Sanyasa
            //Match the yogasanas to the creatures their poses represent, in this order: fish, cobra, peacock, lion
            //Match these films to the lead actors starring in them, in this order: Ra.One, Dabangg, Lagaan, Bhool Bhulaiyaa
            //Arrange the following angles according to their measurement in ascending order? Acute angle, Right angle, Obtuse angle, Reflex angle
            //Arrange these spacecraft in the chronological order of when they were launched?
            //Arrange these sports persons in the chronological order in which they won an Olympic medal? Karnam Malleswari, Abhinav Bindra, Saina Nehwal, Neeraj Chopra
            //Arrange these groups in ascending order based on the number of individuals in them? Pandavas, Saptarishis, Navaratnas, Kauravas
            //Match these Indian districts to their respective states?
            //Arrange these measurements in ascending order?
            //Arrange these Hindi film titles according to the days of the week in their titles, starting from Monday and going forward? Black Friday
            //Arrange these media of mass communication in the chronological order of their invention? NewsPaper, Radio, TV, Internet
            //Arrange the following numbers to form the year in which India celebrated its first Republic Day? 1995
            //Arrange these continents from the biggest to the smallest by area? Asia, Africa, North America, Europe
            //Arrange these elements according to their chemical symbols, in this order: Gold, Calcium, Chlorine, Sodium?
            //Arrange the following in the order as they happen in an ODI match? Toss, First innings, Innings break, Second innings
            //Arrange these personalities in the chronological order of them being awarded the Bharat Ratna? Dr Sarvepalli Radhakrishnan, Nelson Mandela, Sachin Tendulkar, Shri Pranab Mukherjee
            //Match these portfolios with the ministers who hold them as of October 2025: Railways, Petroleum and Natural Gas, Education, Rural Development? Shri Ashwini Vaishnaw, Shri Hardeep Singh Puri, Shri Dharmendra Pradhan, Shri Shivraj Singh Chouhan
            //Arrange these actors in the order in which they were born?
            //Match these shapes to the number of sides they have in this order: Octagon, Pentagon, Square, Triangle? 8, 5, 4, 3
            //Match these regions to their primary environment, in this order: Sahara - Hot desert, Amazon - Rainforest, Atlantic - , Himalayas - Mountain
            //Which of these ornaments is generally worn around the wrist? Bangles
            //Which traditional Char Dham site is located in the westernmost part of our nation? Dwarka
            //In which present-day district did Shuja-ud-Daula build the Chhota Calcutta fort in the eighteenth century? Shuja-ud-Daula built the Chhota Calcutta fort in the 18th century in Faizabad, which is now part of the present-day Ayodhya district in Uttar Pradesh, India.
            //What numeric value does the prefix "deca" in decagram, decametre, and decalitre represent? 10
            //After putting "North" and "South" in front of which of these names would you get two different countries? Korea
            //The function of which of these is similar to a hotel? Lodge
            //What fraction of the total number of Rajya Sabha members retire every second year? 1/3
            //Leo Tolstoy's novel 'War and Peace' is about the nobility of which country? Russian Leo Tolstoy's War and Peace centers on the Russian nobility, chronicling the lives of aristocratic families like the Bolkonskys, Rostovs, and Bezukhovs during the Napoleonic Wars, particularly the French invasion of Russia in 1812

            //Considered to be one of the oldest democracies in the world, the people of Malana village in Himachal Pradesh believe themselves to be descendants of which ruler's soldiers? Alexander

            //CLOTH
            //What does the 'poly' in polymer refer to? Many
            //Which of these fabrics is made from synthetic material? Polyester, Nylon, Acrylic, Spandex, Olefin
            //What is the name of the shorts, extending almost to the knee, that shares its name with a British territory? Bermuda, Chino, Capri, Baggy

            //Statue
            //On which continent is the Statue of Liberty located? North America

            //What record does John Goodenough, who passed away in June 2023 hold, with respect to the Nobel Prize? John Goodenough

            //Author
            //Who won the Booker Prize 2025 in November, becoming the first Hungarian-British author to win the award? Hungarian-British author David Szalay won the 2025 Booker Prize in November for his novel "Flesh," becoming the first writer of Hungarian-British heritage to receive the prestigious award.
            //Published in 1687, which scientist authored the 'Mathematical Principles of Natural Philosophy' in which he postulated three famous laws?  Sir Isaac Newton

            //sarees
            //Which of these fabrics is most commonly used for making Banarasi sarees? Silk

            //Tejasvi is a 17-year-old (as of 2025) from Frisco, Texas - Who was named by Time magazine as the 'Kid of the Year 2025' for her work towards protecting senior citizens from digital crime?
            //Charles Babbage (1791–1871) designed the Analytical Engine - Considered among the first computers, who among these was involved in the development of the Analytical Engine?
            //Swan - Which bird serves as the vahana of Lord Brahma?
            //Shin-chan from Crayon Shin-chan and the titular character Momotaro: Which of these characters is a little boy living in Japan?
            //Africa: On which continent are Saharan silver ants found?
            //Vatican City: Which country is the smallest in the world by area?
            //Five on a Treasure Island is a book by which author?
            //Which of these refers to a high-speed road network? Expressway
            //Doraemon is an anime series from which country? Japan
            //What is the Least Common Multiple (LCM) of 3 and 4? 12
            //What do the letters 'SE' stand for in the abbreviation of the national-level education board CBSE? Central Board of Secondary Education
            //The International Board on Books For Young People's award for lifetime achievement in children's literature, is named after which author? Hans Christian Andersen
            //Match these objects to the subjects they are usually used to study in this order: telescope, geometry box, atlas, test tube: Astronomy or Physics, Mathematics, Geography or Social Studies, Chemistry or Biology
            //'Nobita's Art World Tales' is the subtitle of a 2025 film from which franchise? Doraemon
            //The renamed Teen Murti-Haifa Chowk refers to a city in which present-day country? Israel
            //The preamble to the constitution of which of these countries does not start with the words 'We, the people..'? France
            //In 2022, which Indian nationalist was honoured with a Blue Plaque in his former residence at 72 Anerley Park, London? In 2022, Indian nationalist Dadabhai Naoroji, known as the "Grand Old Man of India," was honoured with a Blue Plaque at his former London residence, Washington House, 72 Anerley Park, where he lived from 1897 to 1904 and worked on his influential "drain theory" of colonialism.
            //Which of these does not have the status of a national party in India? Aam Aadmi Party
            //Which literary character, having a cousin named Tapesh, first made his appearance in a children's magazine in the 1960s? Feluda (Pradosh Chandra Mitra)
            //Kautilya's words 'Kosh Moolo Dandah' can be found on the logo of which organization? Income Tax Department of India
            //The sharp end of a feather was used for which of these purposes before the advent of new technology? Writing
            //What does the 'C' stand for in the Bharat NCAP launched by Shri Nitin Gadkari, the Road Transport and Highways Minister? NCAP stands for New Car Assessment Program
            //Which city is Suketu Mehta's book 'Maximum City' about? Bombay (now known as Mumbai)
            //The 'PET' in PET bottles refers to what material? Polyethylene Terephthalate
            //Which mathematician of Indian origin won the 2023 International Prize? Calyampudi Radhakrishna Rao, known as C.R. Rao
            //Which state is famous for manufacturing Mysore Sandal Soap? Karnataka
            //In which country is Naulakha, the house where Rudyard Kipling wrote The Jungle Book, located? United States
            //Which of the following chemical elements is denoted by a single letter on the periodic table? 1. H - Hydrogen, B - Boron, C - Carbon, N - Nitrogen, O - Oxygen, F - Fluorine, P - Phosphorus, S - Sulfur, K - Potassium, U - Uranium
            //Designed and developed indigenously by the Defence Research and Development Organization (DRDO), which of these is an anti-torpedo decoy system?  Maareech
            //Which nation's communist party did the Indian revolutionary MN Roy help in establishing? Communist Party of Mexico
            //In which of these locations was the armistice ending the fighting in the First World War signed by Germany? railway france
            //Which of these initiatives was headed by Sir George Everest? Great Trigonometrical Survey of India
            //Puyi was the last emperor of the Qing dynasty, which ruled over which country? China
            //Which of these was one of the seven wonders of the ancient world? Great Pyramid of Giza
            //Who was awarded the Nobel Prize when she was a teenager? Malala Yousafzai
            //Which engineering marvel, completed in 1869, inspired the poet Walt Whitman to write the poem 'A Passage to India'? Suez Canal
            //Who lived in 'Hriday Kunj', a house in an ashram in Gujarat, from 1918 until 1930? Mahatma Gandhi and his wife, Kasturba Gandhi
            //In the early 20th century, which country besides France had a protectorate in Morocco? Spain
            //Which freedom fighter is popularly known as 'Bharat Kokila'? Sarojini Naidu
            //Which former princely state shares its name with a present day Indian state capital and a city in Sindh province of Pakistan? hyderabad
            //Lothai is a site associated with which ancient civilization?
            //Westeros is a fictional continent in which entertainment franchise? Game of thrones
            //With which country did India conduct a joint special forces exercise named KHANJAR-XII in 2025? Kyrgyzstan
            //Which organisation formed after World War II Logs been led by people like Trygve Lie and U Thant? United Nations (UN)

            //COMPUTER
            //What does TV in abbreviations like CCTV and HDTV stand for? Television
            //Which symbol, popular on social media, is also known as 'octothorpe', and 'pound' in some countries? #
            //On a laptop, the touchpad can be used to perform the function of which of these? Mouse
            //Which of these pioneers in the development of computers is featured on a British fifty-pound currency note? Alan Turing
            //What is the blinking symbol on a computer screen, indicating the spot where the next character will be typed, called? Cursor

            //BATTLE
            //The king Dantidurga overthrew which dynasty by defeating Kirtivarman II to establish the rule of the Rashtrakutas? Chalukya dynasty
            //Which Maratha statesman was the commander of the Maratha armies at the Third Battle of Panipat? Sadashiv Rao Bhau (also called Bhau Sahib)

            //MUSEUM
            //Which museum was the site of a 2025 jewel heist where several royal artefacts, including Empress Eugenie's tiara, were stolen? Louvre Museum

            //SPORTS
            //How many dark-coloured squares does a chess board have? 32
            //In tennis, what is the point that is won right after a deuce called? Advantage or Ad
            //In badminton, what is a long exchange of shots between players called? rally
            //Written by Shamya Dasgupta, 'Bhiwani Junction' is the untold story of what sport in India? boxing
            //What is the term used for the person who officiates a football match on the field? Referee
            //Who among these is a former World No.1 tennis player, and is married to another former World No.1 tennis player? Steffi Graf and Andre Agassi
            //Who in 2025, became the first Indian to win a / 1:05:3rmula 2 sprint race at the iconic Monaco circuit? Kush Maini
            //'The Rise of the Hitman' by R Kaushik is a book about which cricketer? Rohit Sharma
            //In which of these sports would you find some players in a sitting position on the field of play? Kho Kho
            //The new hockey stadium being built to host World Cup matches in Rourkela is named after who among these? Birsa Munda
            //Which city, that initially won the bid to host the 2022 Commonwealth Games, was later stripped of the rights to do so? Durban, South Africa
            //What surname is common to the first foreign coaches of the Indian men's national football and cricket teams? men's cricket (John Wright) and football (Harry Wright)
            //The lid of the trophy of the Sudirman Cup, an international badminton tournament, is designed to resemble which religious structure? Borobudur Temple
            //Who among these is most likely to play in a grand slam tournament named 'Australian Open'? Rafael nadal
            //Which country has won the Thomas Cup, an international badminton competition, the maximum number of times? Indonesia
            //What name is common to an attacking position in football and the piece used to hit other pieces in carrom? Striker
            //Dorabji Tata decided to arrange funding for the Indian contingent for their first ever Olympics in 1920 after attending a competition at which club? e Deccan Gymkhana Club in Pune, India
            //Which of these sporting equipments has a string? Archery bow
            //Which sport does the novel "The Zoya Factor' revolve around? Cricket
            //Which pair of tennis Grand Slams should a player win in the same year to complete the 'Channel Slam'? French Open, Wimbledon
            //Chhatrapati Sambhajinagar is a district located in which state? Maharashtra
            //At the Olympic Games, which medal does an individual or team at the second place receive? Silver
            //Which nation won the gold in the women's section of the 44th Chess Olympiad held in Chennai? Ukraine
            //Which of these is required to play 'rummy'? Playing cards
            //Which umpire was at the bowler's end during all the dismissals when Anil Kumble took 10 wickets in a Test innings? A.V. Jayaprakash
            //A penguin named Tazuni served as the mascot of which sporting event in 2023? Tazuni, a penguin, was the official mascot for the 2023 FIFA Women's World Cup, hosted in Australia and New Zealand, symbolizing the Tasman Sea and the unity of the event with her name.
            //In 2025, who became the first person of Indian origin to be appointed as head coach of the WNBA team Seattle Storm in the USA? Sonia Raman
            //Who became the Formula 1 World Champion in the 2022 season winning his second consecutive title? Max Verstappen
            //When a run is scored off a ball which neither hits the bat nor the body of the batter, what is it called? Bye
            //Which of these sports does not require the contestant to hold any equipment in their hands? Long jump
            //As per BWF regulations, which sports equipment is made with 16 feathers? : shuttlecock Badminton
            //Which is the only team in men's international cricket to have won all major ICC trophies across formats? Australia
            //Who is the first Indian woman footballer to play in the UEFA Women's Champions League? Manisha Kalyan
            //What is the colour of the court on which Wimbledon, one of the oldest tennis tournaments in the world, is played? green
            //The Orchha Fort Complex is a tourist attraction in which state? Madhya Pradesh
            //Speedcubing involves solving which puzzle as quickly as possible? Rubik's Cube
            //In which of these sports would you typically play a 'drop shot'? tennis, badminton, and squash
            //Will Smith won the 2022 Oscar for Best Actor for playing Richard, the father of which two tennis players?
            //Will Smith won the 2022 Oscar for Best Actor for playing Richard, the father of which two tennis players? Hospital
            //Match these players to the sports they are mainly associated with, in this order: Divya Deshmukh, Harmanpreet Kaur, Sania Mirza, PV Sindhu - Chess, Cricket, Tennis, Badminton
            //While playing which of these sports would a player usually wear goggles? Swimming
            //IPLનો ઑફિશિયલ મોટ્ટો (સૂત્ર) છે, 'Yatra Pratibha Avsara Prapnotihi', જેનો મતલબ થાય છે...Where Talent Meets Opportunity (જ્યાં પ્રતિભાઓને તક મળે છે).
            //Koneru Humpy and Pravin Thipsay have both achieved which of the following titles in their sport? Grandmaster (GM)
            //Arrange these IPL teams from north to south according to the cities they are based in Capitals, Indians, Sunrisers, Super Kings
            //In 1971, what animal did Indian fans bring to the ground, when India won its first ever Test series in England? Elephant named Bella
            //Will Smith won the 2022 Oscar for Best Actor for playing Richard, the father of which two tennis players?
            //Olympic medal-winning shooter Manu Bhaker has also won medals at the national level in which indigenous martial art form? Olympic medal-winning shooter Manu Bhaker has also won national-level medals in the indigenous martial art form of Thang Ta. She is a multi-talented athlete who also excelled in sports like tennis, skating, and boxing during her school years before focusing on shooting.
            //Which of these cities has hosted the Summer Olympics, but not the Commonwealth Games? Cities like Los Angeles, Atlanta, Athens, Tokyo, Rio de Janeiro, Seoul, and Mexico City have hosted the Summer Olympics but never the Commonwealth Games, as the latter is restricted to Commonwealth nations (like the US, Greece, Japan, Brazil, South Korea, Mexico aren't members). Los Angeles, for example, hosted in 1932 & 1984 but isn't in the Commonwealth.
            //What did the sons of Milton and Susan Wright invent?

            //PHRASE
            //Acording to a common English phrase, if a person is "pulling omeone's leg", what are they very likely? Joking
            //Which ancient scholar wrote: "In the happiness of his subjects lies the king's happiness; in their welfare his welfare"? Chanakya)
            //Which city is called the "home of the Alphonso mango"? Ratnagiri
            //The historic 'Jai Jawan Jai Kisan' slogan was made in reference to India's fight during which of these? 1965 India-Pakistan War
            //The full name of which of these characters is Barbara Millicent Roberts? Barbie
            //Which of these saints wrote the devotional poem called 'Pasayadan'? Sant Dnyaneshwar, Sant Namdev, Sant Eknath, Sant Ramdas
            //Which Shakespearean play was the basis of Habib Tanvir's 'Kamdev ka Apna Basant Ritu ka Sapna'? A Midsummer Night's Dream
            //Complete this common English proverb: All that glitters is not Gold
            //Which profession is associated with the chant 'abracadabra'? Magician
            //Which of these statements would be used to make a guest feel comfortable? Apna hi ghar samjho
            //By which Hindi proverb would you relate a situation of dilemma? Udhedbun mein padna
            //What kind of person is described by the phrase 'chamdi jaaye, par damdi na jaaye'? Miserly

            //In Sahir Ludhianvi's pen-name, if 'Ludhianvi' means that he is from Ludhiana, what does 'Sahir' mean? "magician" or "enchanter"

            //Investor
            //The Nikkei 225 is the stock index of which country? Japan
            //BSE and NSE are stock exchanges located in which city? Mumbai
            //What do you call an investor who provides capital for a business start-up, usually in exchange for ownership equity? Angel Investor

            //
            //Jhalkari Bai led the Durga Dal, he women's wing of whose army? Rani Lakshmibai

            //TEMPLE
            //Which reconstructed temple was dedicated to the nation by the President of India, Shankar Dayal Sharma, in 1995? Somnath Temple
            //Makrana marble, that was used to construct the Taj Mahal, is named after a place in which state? Nagaur district of Rajasthan
            //Who among these was not alive when the Taj Mahal was being built? Jahangir
            //How many dishes or bhog are traditionally offered to Lord Jagannath in the temple at Puri? 56
            //The Badami cave temples in Karnataka were built during the reign of which dynasty? Chalukyas
            //Where can you find the Kalapani Museum? Garacharama, Port Blair, Andaman and Nicobar Islands, India
            //Which of these structures is also known as Rabindra Setu? Howrah Bridge
            //Which of these places in West Bengal was declared a UNESCO World Heritage Site in 2023? Santiniketan

            //Chhatrapati Shivaji Maharaj renamed the Kondhana fort in Pune to Sinhagad in the honour of which Maratha general? Tanaji Malusare

            //WORK
            //Which place did Nikita Khrushchev describe as the 'Magnitogorsk of India', comparing it to Russia's largest iron and steel works? Bhilai

            //CALENDAR
            //In the Hindu lunar calendar what are Krishna and Shukla? Shukla Paksha (Bright Fortnight) and Krishna Paksha (Dark Fortnight) are the two halves of a lunar month, each lasting about 15 days (tithis), representing the waxing (growing) and waning (shrinking) phases of the moon, respectively, and are crucial for timing festivals and spiritual practices.

            //GOD
            //In the Kurukshetra War, what kind of animal was Bhagadatta riding, when he was killed by Arjuna? elephant
            //In the Valmiki Ramayana, who was Sharabhanga, who ascended to Brahmaloka after Lord Rama met him? A rishi
            //Which of these Hindu gods was armed with a bow made of sugarcane and shot arrows made from flowers? Lord Kama
            //Which of these gods is also known as Nandishwara and Chandranath? Lord Shiva
            //According to the Padma Purana, which king had to live as a tiger for a hundred years due to a deer's curse? Prabhanjana
            //According to ancient scriptures King Harishchandra, known for his truthfulness, was the son of which king? Trishanku
            //Immediately after whose death did Sanjaya lose his divine vision to see the battle of Kurukshetra? Duryodhana
            //After their meeting at Ashoka Vatika, what object did Devi Sita give to Lord Hanuman to take to Lord Rama? Her hair ornament
            //According to Hindu religious texts, Lord Rama killed Ravana on which of these dates? Dashami
            //According to the Mahabharata, who among these jumped into Pandu's funeral pyre upon his death? Madri, one of Pandu's wives
            //In the Mahabharata, which of these warriors created the Chakravyuha during the battle at Kurukshetra? Dronacharya
            //During the Kurukshetra war, which Pandava killed Shalya? Yudhishthira, eldest Pandava
            //To which country that hosted the Global Peace Prayer Festival in 2025 did India send sacred relics of the Lord Buddha? Bhutan
            //In which country will you find a 75-metre tall statue of Lord Vishnu riding Garuda? Garuda Wisnu Kencana (GWK) statue, in Indonesia
            //Which rishi's sudden arrival at the Pandava camp in exile embarrassed Draupadi because she had no food left to feed him and his followers? Sage Durvasa
            //According to the Puranas, which son of Sri Krishna and Rukmini was kidnapped as a baby, thrown into the sea and swallowed by a fish? Pradyumna
            //Which of these avatars of Lord Vishnu took the form of a fish? Lord Matsya
            //According to the Devi Bhagavata Purana who among these gods was born from a lotus flower emerging from the navel of Lord Vishnu? Brahma
            //Who motivated Lord Hanuman to jump across the sea to Lanka by reminding him about his noble origin and powers? Jambavan (Jambavanta)
            //According to the Mahabharata, whom did the Kauravas try to kill by giving him poisoned food? Bhima
            //What is the longest side of a right-angled triangle called? Hypotenuse, Perimeter, Perpendicular, Longitude
            //In Hindu mythology, on the back of which of Lord Vishnu's avatars was Mount Mandara placed for the samudra manthan? Kurma
            //According to the Valmiki Ramayana, Kishkindha was the kingdom of which of these groups? Vanaras
            //The Dharmachakrapravartana Sutra is considered to be the first sermon given by who among the following? Gautama Buddha
            //Identify this Buddhist monastery, the largest in India? Tawang Monastery (Galden Namgey Lhatse) in Arunachal Pradesh
            //In the Mahabharata, who was the commander-in-chief of the Kaurava army for the most number of days? Bhishma: Days 1-10 (10 days), Dronacharya: Days 11-15 (5 days), Karna: Days 16-17 (2 days), Shalya: Day 18 (1 day), Ashwatthama: The final night/day (remaining forces)
            //Which deity is worshipped at the Somnath Temple located on the western coast of Gujarat? Lord Shiva
            //After the Kurukshetra war, who was crowned king? Yudhishthira
            //In the Ramayana, which of these members of King Dasharatha's family is the youngest? Luv
            //Who among these was an uncle of Ravana? Maricha
            //In which state is the Omkareshwar Jyotirlinga located? Madhya Pradesh
            //According to the Mahabharata, which of these Pandavas was also known as Vrikodara? Bhima meaning "wolf-bellied" or "voracious eater"
            //Which of the following words and their antonyms is incorrectly matched? Shubh - Labh
            //In the name of the festival, Karva Chauth, what does 'Karva' mean? Earthen pot
            //Who among these was born as a result of the Putrakameshti Yagna performed by his father to have children? Rama
            //In Hindu mythology, which of these goddesses is also known as Veena-paani? Devi Saraswati
            //According to Hindu mythology, what was the name of the poison that Lord Shiva stored in his throat after the churning of the ocean? Kalakuta
            //According to Hindu scriptures, which of these was created from the bones of a sage?  the Vajra (thunderbolt weapon) of the deity Indra was created from the bones of the revered sage Dadhichi.
            //The father of who among these was an incarnation of Lord Vishnu? Luv - Kush
            //According to the Bhagavad Gita, upon whose request did Lord Krishna reveal his 'Vishvarupa'? Arjuna
            //In Hindu mythology, from whom did Ravana take the Pushpaka Vimana by force? In Hindu mythology, Ravana took the Pushpaka Vimana by force from his half-brother Kubera, the god of wealth, after defeating him in a fierce battle and conquering his city of Lanka.
            //According to Hindu mythology, who was the mother of Bharata, from whom our country gets its name? Shakuntala
            //According to the Mahabharata, Lord Indra asked which Pandava to kill a group of asuras called the Nivatakavachas? Arjun
            //According to the Mahabharata, what was the name of King Virata's wife, whose companion Draupadi became, when in hiding? Sudeshna
            //Who among these is also known as Anjaneya and was born to Anjana? Hanuman
            //Which stupa in Uttar Pradesh is believed to commemorate Gautama Buddha's first sermon after enlightenment? The Dhamek Stupa in Sarnath, Uttar Pradesh, is believed to commemorate Gautama Buddha's first sermon.
            //In Hindu mythology, which apsara made Sage Vishwamitra break his penance? The Apsara who made Sage Vishwamitra break his penance was Menaka, a celestial nymph sent by Indra the king of the Devas to disrupt his intense austerities, fearing his growing power; she succeeded, and they had a daughter, Shakuntala, before she left.
            //The Dashashwamedh Ghat in Varanasi is believed to get its name because Lord Brahma sacrificed ten animals of what kind there? Horse
            //According to the Valmiki Ramayana, who among these performed the funeral rites of Dasaratha? Bharata

            //Who among these was the last king of the Mauryan empire? Brihadratha

            //CITY
            //Before marriage, former Maharani Gayatri Devi of Jaipur was the princess of which princely state? Gayatri Devi was Princess Gayatri Devi of Cooch Behar
            //Which of these cities did not exist before August 15, 1947? Chandigarh
            //In Aug 2022, PM Shri Narendra Modi dedicated the Smriti Van Memorial in Bhuj, Gujarat to victims of what disaster? Earthquake
            //Which of these connects names like Palk, Malacca, and Gibraltar? All are straits
            //'Shahjahanabad' by Rana Safvi is the third book in her trilogy that chronicles the history of which city? //Delhi

            //INTERNATIONAL ORGANIZATIONS
            //Which of these international organizations has the least number of member countries? SAARC

            //COUNTRY
            //Who is the longest serving Speaker of the Lok Sabha? Balram Jakhar, whose tenure spanned over 9 years (9 years and 329 days) across multiple terms
            //Which American missionary trained the social reformer Savitribai Phule to become recognised as the first female teacher of India? Cynthia Farrar
            //The father of which Viceroy of India coined the English phrase 'the pen is mightier than the sword'? Edward Bulwer-Lytton
            //Ytterby, a village in which country, has four elements in the modern periodic table named after it? Sweden
            //Which national park in India has an official mascot named 'Bhoorsingh the Barasingha'? Kanha National Park, Madhya Pradesh
            //During World War I, at which battle in Turkey in 1915-16 did around 16,000 Indian army soldiers bravely fight along with the Allies? Gallipoli Campaign
            //Alberto Fujimori, a person of Japanese descent, served as the president of which country from 1990-2000? Peru
            //Who among these freedom fighters witnessed the first morning of independent India? Mahatma Gandhi, Jawaharlal Nehru, Sardar Vallabhbhai Patel, Maulana Abul Kalam Azad, Dr. Rajendra Prasad, Sarojini Naidu, Sucheta Kriplani, Sardar Ajit Singh
            //The 'Gold Dagger' is an annual award given to books published in which of these genres? Crime fiction
            //Which religious structure's name features inside the surname of this former Prime Minister of the United Kingdom? Church
            //Which of these is not one of the four regions of Ukraine annexed by Russia in September 2022? Lviv (Donetsk, Luhansk, Kherson, Zaporizhzhia)
            //What is the nationality of the 2022 Nobel laureate for Literature, Annie Ernaux? French
            //Which emperor established a national decoration named the 'Order of the Rising Sun' in 1875? Emperor Meiji
            //Which post did the founder of Osmania University in Hyderabad occupy? Nizam
            //Dassault is a company from which country? France
            //The Punjab Regiment has its Regimental Centre not in Punjab, but in which other state? Jharkhand
            //In 2025, what was the US Department of Defense renamed to? Department of War
            //What does the Bin BRICS (Brazil, Russia, India, China, South Africa), a group of five major emerging countries, stand for?  Brazil, China, Egypt, Ethiopia, India, Indonesia, Iran, Russia, South Africa and the United Arab Emirates
            //Between 1994 and 2006, President Ram Nath Kovind was a member of the Rajya Sabha representing which Indian state? Uttar Pradesh (UP)
            //Which of these languages is traditionally spoken in the westernmost part of India? Gujarati
            //Which of these countries falls entirely in Europe? Ukraine
            //In 2025, a reprint of which European scholar's 18th-century Sanskrit Grammar was presented to PM Shri Narendra Modi by the Croatian Prime Minister? A reprint of Filip Vezdin's (also known as Paulinus a Sancto Bartholomaeo) 18th-century Sanskrit grammar, titled Sidharubam seu Grammatica Samscrdamica (1790), was presented to PM Narendra Modi by the Croatian Prime Minister Andrej Plenković in June 2025.
            //What was the aircraft that dropped the first atomic bomb on Hiroshima on 6th August, 1945, named after? B-29 Superfortress bomber named the Enola Gay The pilot's mother
            //In which country is the Salma Dam, built with Indian assistance, located? Afghanistan
            //The announcement of transfer of power to India and Pakistan, made in June 1947, was popularly referred to by which name? Mountbatten Plan

            //'Khooni Vaisakhi' by Nanak Singh is an account of which event from Indian history? Jallianwala Bagh massacre

            //In February 2021, what was named by Oxford Languages as its Hindi word of the year 2020? Aatmanirbharta

            //
            //Which of these is common to these former Prime Ministers? Served as Union finance ministers

            //Mobile
            //In a smartphone device, what among these is generally shown as percentage? Battery level
            //While looking through the contacts list in your mobile phone, which of these surnames would appear first? Kohli
            //The DynaTAC 8000X, the world's first portable cell phone, was invented by which company? Motorola, with engineer Martin Cooper leading the team that developed the prototype and made the first mobile call in 1973, leading to its release in 1983/1984.

            //TAX SAVING
            //The terms 'bullish' and 'bearish' are generally used to describe the behaviour of which of these entities? Stock markets
            //Which of these is a type of mutual fund commonly used for its tax-saving benefits? ELLS
            //Which state has a GI Tag for Kutch embroidery? Gujarat
            //In July 2022, which department of the Government of India has launched a mascot called Jagriti? In July 2022, the Department of Consumer Affairs (DoCA), under the Indian government, launched the "Jagriti" mascot to empower consumers and raise awareness about their rights, featuring her in campaigns alongside the "Jago Grahak Jago" tagline.

            //SPACE
            //Who was the first Indian female fighter pilot selected to fly the Rafale? Shivangi Singh
            //On which island separating Pulicat Lake and the Bay of Bengal is the Satish Dhawan Space Center located? Sriharikota Island
            //Normally, which of these is made from electrons, protons, and a nucleus? Atom
            //In July 2022, which country launched a second module named Wentian, to its under-construction space station? China
            //Which of these is the smallest? (electron, proton, or neutron)
            //In which state is the Kaiga Atomic Power Station located? Karnataka
            //A liquid form of which of these elements has been used as a fuel component in rockets used by space agencies? oxygen

            //Line Divides
            //The Wallace Line is an imaginary boundary that divides which of these nations into regions of distinct biodiversity? The Wallace Line divides the Indonesian archipelago, separating the distinct Asian and Australian faunal realms, meaning it splits the unique biodiversity of Indonesia into Asian-influenced (west) and Australian-influenced (east) zones, with animals like tigers and orangutans on one side, and marsupials like tree kangaroos on the other, despite islands being close.

            //Food
            //What method is used to prepare tele bhaja, a crispy snack made from seasonal vegetables?

            //Unit
            //Which of these is the unit of electric resistance? Ohm
            //According to legend, which ancient mathematician designed weapons using mirrors to focus sunlight and set enemy ships on fire? Archimedes

            //Window, split, and central are some of the classifications used to classify which luxury household item? Air conditioner

            //In terms of size, which of these accessories worn by women is usually the smallest? Nathani

            //Music
            //The santoor is an instrument most associated with which of these legendary musicians? Pandit Shivkumar Sharma

            //MOVIE
            //In which series does Manoj Bajpayee play intelligence officer Srikant Tiwari?
            //Who composed "Arpa Pairi Ke Dhar" which is the state song of Chhattisgarh? Dr. Narendra Dev Verma
            //Which of these beauty products is used to make eyelashes darker so that they appear to be thicker? mascara
            //While filming, what is the wheeled device used to create smooth horizontal camera movements called? Dolly
            //If John Paul II and Benedict XVI were the last two, who is the latest? John Paul II (1978–2005), Benedict XVI (2005–2013), Francis (2013–2025), Leo XIV (2025–Present)
            //On her visit to India, Helen Clark, the then-PM of New Zealand, felicitated whom for popularising New Zealand through his 2000 film? Rakesh Roshan
            //What is the name of Asha Bhosle and Lata Mangeshkar's brother? Hridaynath
            //Whom did Manisha Koirala play in the film Sanju? Nargis
            //Professor Moriarty is the main antagonist in stories about which fictional detective? Sherlock Holmes
            //A matinee movie screening is generally during which of these times of the day? afternoon
            //The song 'Chaiyya Chaiyya' from the film 'Dil Se' was shot on top of a UNESCO World Heritage Site in which state? //Tamil Nadu

            //What is the study of living things and their environment called? Ecology, Dermatology, Oncology, Nanotechnology

            //Which of these elements is named after a mythological figure, who was the inspiration for a Marvel superhero? Thorium
            //'Master Chief Petty Officer Ist Class' is a rank in which branch of the Indian Armed Forces? Navy
            //What does the 'HA' in HAWS, a warfare school run by the Indian Army in Gurmarg, stand for? High Altitude Warfare School)

            //FORMULA
            //Which greenhouse gas has the formula N20?

            //CURRENCY
            //If you take 10 minutes to read 5 pages of a novel, how many pages will you finish reading in 20 minutes? 10
            //Sudipa has 15 notes of the denominations of Rs 2, 5, and 10 and the number of notes is equal for each denomination. How much money does she have in total? Step:1 - 15÷3=5 85 Step: - (2*5 = 10, 5*5 = 25, 5*10 = 50 = Step:3 - (10+25+50) 85)
            //Going from top to bottom, which language appears first on the language panel of an Indian currency note?
        }
    }
}

//https://www.youtube.com/watch?v=KUHP-baZrwg
